import styled, { css } from 'styled-components';
import { GhostAction } from '@/common/styles/shared.styles';
import { THEME } from '@/common/styles/theme';

export const PersonMediaSkeleton = styled.div`
	position: absolute;
	inset: 0;
	z-index: -2;
`;

export const PersonImage = styled.img`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: ${(props) => (props.$visible ? 1 : 0)};
	visibility: ${(props) => (props.$visible ? 'visible' : 'hidden')};
	transition: opacity 180ms ease, transform 180ms ease, visibility 180ms ease;
	z-index: -2;
`;

export const PersonVideo = styled.video`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0;
	transition: opacity 180ms ease, transform 180ms ease;
	z-index: -2;
`;

export const PersonCard = styled.article`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: auto;
	aspect-ratio: 0.72;
	border: 0;
	border-radius: 24px;
	background: #070509;
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);
	isolation: isolate;
	cursor: pointer;

	${(props) =>
		props.$discover &&
		css`
			height: clamp(560px, 74vh, 680px);
			margin-bottom: 18px;
			scroll-snap-align: start;
		`}

	${(props) =>
		props.$hasVideo &&
		css`
			&:hover ${PersonVideo} {
				opacity: 1;
			}

			&:hover ${PersonImage} {
				opacity: 0;
			}
		`}

	&:hover ${PersonImage},
	&:hover ${PersonVideo} {
		transform: scale(1.04);
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		border-radius: 16px;
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.36);
		aspect-ratio: 0.72;

		&:hover ${PersonImage},
		&:hover ${PersonVideo} {
			transform: none;
		}
	}
`;

export const PersonShade = styled.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0.04) 0%,
		rgba(0, 0, 0, 0.02) 48%,
		rgba(0, 0, 0, 0.76) 100%
	);
	z-index: -1;
`;

export const ReloadButton = styled(GhostAction)`
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 2;
	min-height: 36px;
	padding: 0 10px;
`;

export const PersonInfo = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 0 22px 22px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 0 10px 12px;
	}
`;

export const PersonTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 6px;

	h3 {
		margin-bottom: 0;
		font-family: ${THEME.fontApp};
		font-size: clamp(1.32rem, 1.55vw, 1.58rem);
		font-weight: 600;
		line-height: 1;
		letter-spacing: 0;
		text-shadow: 0 2px 14px rgba(0, 0, 0, 0.66);

		span {
			margin-left: 2px;
			color: rgba(255, 255, 255, 0.66);
			font-size: 0.82em;
			font-weight: 500;
		}
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		gap: 4px;
		margin-bottom: 4px;

		h3 {
			font-size: clamp(0.98rem, 3.8vw, 1.08rem);
			line-height: 1.08;
		}
	}
`;

export const Bio = styled.p`
	display: -webkit-box;
	margin-bottom: 0;
	max-width: 94%;
	color: rgba(255, 246, 255, 0.76);
	font-family: ${THEME.fontApp};
	font-size: 0.86rem;
	font-weight: 400;
	line-height: 1.28;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-shadow: 0 2px 12px rgba(0, 0, 0, 0.68);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		max-width: 100%;
		font-size: 0.8125rem;
		line-height: 1.3;
		-webkit-line-clamp: 2;
	}
`;
